import { Pipe, PipeTransform } from '@angular/core';

export interface FinancialYear {
  startDate: string;
  endDate: string;
}

export function formatFinYear(value: FinancialYear | undefined) {
  if (!value || !value.startDate || !value.endDate) {
    return null;
  }

  let startYear = value.startDate.split('-')[0];
  let endYear = value.endDate.split('-')[0];

  if (!startYear || !endYear) {
    return null;
  }

  // Is it in the last 6 days of the year
  if (/-12-(2[6-9]|3[01])\b/.test(value.startDate)) {
    startYear = (+startYear + 1).toString();
  }

  // Is it in the first 6 days of the year
  if (/-01-0[1-6]\b/.test(value.endDate)) {
    endYear = (+endYear - 1).toString();
  }

  return `${startYear}‑${endYear}`.replace(
    /^(\d+)(\d{2})(\D)(\d+)(\d{2})$/,
    (all, fromStart, fromEnd, range, toStart, toEnd) => {
      if (fromStart === toStart) {
        if (fromEnd === toEnd) {
          return fromStart + fromEnd;
        }

        return fromStart + fromEnd + range + toEnd;
      }

      return all;
    },
  );
}

@Pipe({
  name: 'aafinyear',
  standalone: false,
})
export class AaFinYearPipe implements PipeTransform {
  constructor() {}

  transform = formatFinYear;
}
